import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const Loading = (props) => {
    return (
        <div
            className={classNames({
                'p-loading': true,
                [`p-loading--${props.theme}`]: props.theme !== undefined,
                [`p-loading--${props.size}`]: props.size !== undefined,
                [`p-loading--${props.display}`]: props.display !== undefined,
                [`p-loading--${props.position}`]: props.position !== undefined
            })}
        >
            <div
                className={classNames({
                    'p-loading__indicator': true,
                    [`p-loading__indicator--${props.size}`]: props.size !== undefined,
                    [`p-loading__indicator--${props.theme}`]: props.theme !== undefined,
                    [`p-loading__indicator--${props.display}`]: props.display !== undefined,
                    [`p-loading__indicator--${props.position}`]: props.position !== undefined
                })}
            />
        </div>
    );
};

Loading.propTypes = {
    theme: PropTypes.oneOf(['dark']),
    size: PropTypes.oneOf(['small']),
    display: PropTypes.oneOf(['fixed', 'overlay', 'hidden']),
    position: PropTypes.oneOf(['center'])
};

Loading.defaultProps = {
    theme: undefined,
    size: undefined,
    display: undefined,
    position: undefined
};

export default Loading;
